<div class="px-4 pt-4 pb-2">
  <div class="flex items-center justify-between mb-2">
    <span class="eko-sidebar-section-label">
      {{ 'companyContext.subject' | translate }}
    </span>
    <button
      class="p-1.5 text-gray-500 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-all duration-200"
      (click)="goToCompanies()"
      [pTooltip]="'companyContext.manage' | translate"
      tooltipPosition="top">
      <i class="pi pi-cog text-sm"></i>
    </button>
  </div>

  <ng-container *ngIf="loading$ | async; else loadedState">
    <p-skeleton height="40px" borderRadius="8px"></p-skeleton>
  </ng-container>

  <ng-template #loadedState>
    <ng-container *ngIf="error$ | async as errorKey; else companyState">
      <div class="flex items-center gap-3 py-2 text-sm text-red-700 dark:text-red-300">
        <i class="pi pi-exclamation-circle text-red-500 dark:text-red-400"></i>
        <span>{{ errorKey | translate }}</span>
      </div>
    </ng-container>

    <ng-template #companyState>
      <ng-container *ngIf="companies$ | async as companies">
        <div
          *ngIf="companies.length === 0; else companySelect"
          class="flex items-center gap-3 py-2 text-gray-600 dark:text-gray-400 text-sm"
        >
          <i class="pi pi-building text-gray-400"></i>
          <span>{{ 'companyContext.empty' | translate }}</span>
        </div>

        <ng-template #companySelect>
          <div class="relative">
            <p-select
              [options]="companies"
              optionLabel="name"
              optionValue="id"
              [ngModel]="selectedCompanyId$ | async"
              (ngModelChange)="onCompanyChange($event)"
              styleClass="w-full company-dropdown"
              panelStyleClass="company-panel"
              [fluid]="true"
              appendTo="body"
              [filter]="true"
              filterBy="name">

              <ng-template let-item pTemplate="selectedItem">
                <div class="flex items-center gap-3 py-1">
                  <div class="w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
                    <img
                      src="https://ui-avatars.com/api/?size=32&background=597A4F&color=ffffff&name={{ item?.name }}"
                      class="w-full h-full object-cover"
                      [alt]="item?.name" />
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="font-medium text-gray-900 dark:text-gray-100 truncate">{{ item?.name }}</div>
                  </div>
                </div>
              </ng-template>

              <ng-template let-item pTemplate="item">
                <div class="flex items-center gap-3 p-2">
                  <div class="w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
                    <img
                      src="https://ui-avatars.com/api/?size=32&background=597A4F&color=ffffff&name={{ item?.name }}"
                      class="w-full h-full object-cover"
                      [alt]="item?.name" />
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="font-medium text-gray-900 dark:text-gray-100 truncate">{{ item?.name }}</div>
                  </div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </ng-template>
      </ng-container>
    </ng-template>
  </ng-template>
</div>

<p-dialog
  [visible]="showNoCompaniesDialog"
  [modal]="true"
  appendTo="body"
  [baseZIndex]="2000"
  [draggable]="false"
  [closable]="false"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [showHeader]="false"
  styleClass="entity-setup-dialog"
  [style]="{ width: 'min(50vw, 94vw)' }"
>
  <div class="flex flex-col items-center justify-center text-center p-6 gap-4">
    <i class="pi pi-building !text-6xl text-primary-500"></i>

    <h2 class="text-2xl font-semibold text-gray-800 dark:text-gray-100">
      {{ 'entitySetup.title' | translate }}
    </h2>

    <p class="text-gray-600 dark:text-gray-300 max-w-md">
      {{ 'entitySetup.description' | translate }}
    </p>

    <p-button
      [label]="'entitySetup.goToCompanies' | translate"
      icon="pi pi-arrow-right"
      (onClick)="goToCompanies()"
      styleClass="p-button-rounded p-button-lg"
    />
  </div>
</p-dialog>
